import { atomWithStorage } from 'jotai/utils';
import { makeJotaiSessionStorage } from './createSessionStorage';
import { SyncStorage } from 'jotai/vanilla/utils/atomWithStorage';

const initialUserInfor: UserInfor = {
  usridx: 0,
  usrname: '',
  usremail: '',
  usrnickname: '',
  joindate: '',
  loginate: '',
  dormantdate: null,
  isdormant: false
};

const localStorageKey = 'userInformation';

const userInforAtom = atomWithStorage(
  localStorageKey,
  initialUserInfor,
  makeJotaiSessionStorage() as SyncStorage<UserInfor>
);

export default userInforAtom;
